import React from 'react'
import TextSection from '../../shared/cookieWarning/componenteTexto'
import CookiesTable from '../../shared/cookieWarning/coponenteTabla'
function CookiePolicy (): any {
  return (
    <div className=" pt-44 text-left mx-[120px]  min-h-screen">
        <TextSection title="Uso de Cookies en Criterian.es">
            En Criterian.es utilizamos Google Analytics para analizar el tráfico del sitio web. Esta herramienta nos ayuda a contabilizar el número de visitas y entender cómo los
            usuarios navegan por nuestra página, con el objetivo de mejorar su funcionamiento y ofrecer una mejor experiencia.<br /> Toda la información recopilada por Google Analytics es completamente
            anónima y no permite identificar personalmente a los visitantes.
        </TextSection>

        <TextSection title="Cómo desactivar las cookies">
            Aunque no se recomienda desactivar las cookies, ya que pueden afectar el correcto funcionamiento del sitio, tienes la opción de hacerlo. Si deseas desactivarlas, consulta la sección de
            Ayuda de tu navegador para obtener instrucciones sobre cómo modificar la configuración de cookies.
        </TextSection>

        <TextSection title="Información sobre las cookies">
            Para conocer en detalle qué cookies utilizamos, su duración y finalidad, consulta la sección Datos de las Cookies en esta misma página.
        </TextSection>
        <CookiesTable />
  </div>
  )
}
export default CookiePolicy
